import { message } from 'antd';
import { call, put, takeLatest, all, select } from "redux-saga/effects";
import { addNewPatientAPI, addUpdatePatientNotesAPI, fetchPatientNotesAPI, fetchPatientsBySearchAPI, getPatientDocumentsAPI, uploadPatientDocumentAPI, mergePatientsAPI, deletePatientDocumentAPI, searchPatientAPI } from "../../../services/appointments-patient-visits-service";
import { ADD_NEW_PATIENT, ADD_NEW_PATIENT_ERROR, ADD_NEW_PATIENT_START, ADD_NEW_PATIENT_SUCCESS, ADD_UPDATE_PATIENT_NOTES, ADD_UPDATE_PATIENT_NOTES_ERROR, ADD_UPDATE_PATIENT_NOTES_SUCCESS, MERGE_PATIENTS, MERGE_PATIENTS_SUCCESS, MERGE_PATIENTS_ERROR, REMOVE_MERGE_PATIENTS, DELETE_PATIENT_DOCUMENT, DELETE_PATIENT_DOCUMENT_ERROR, DELETE_PATIENT_DOCUMENT_SUCCESS, FETCH_PATIENTS_BY_SEARCH, FETCH_PATIENTS_BY_SEARCH_ERROR, FETCH_PATIENTS_BY_SEARCH_START, FETCH_PATIENTS_BY_SEARCH_SUCCESS, FETCH_PATIENT_DOCUMENTS, FETCH_PATIENT_DOCUMENTS_ERROR, FETCH_PATIENT_DOCUMENTS_SUCCESS, FETCH_PATIENT_NOTES, FETCH_PATIENT_NOTES_ERROR, FETCH_PATIENT_NOTES_SUCCESS, SET_SELECTED_PATIENT, SET_SELECTED_PATIENT_SUCCESS, UPDATE_PATIENT, UPDATE_PATIENT_ERROR, UPDATE_PATIENT_START, UPDATE_PATIENT_SUCCESS, UPLOAD_PATIENT_DOCUMENT, UPLOAD_PATIENT_DOCUMENT_ERROR, UPLOAD_PATIENT_DOCUMENT_SUCCESS } from "../../actions/receptionist/patientsAction";
import _ from 'lodash';
import { history } from '../../store';
import { navigateTo } from '../../../util/navigationService';

const getPatientsState = (state) => state.receptionist.patients;

function* fetchPatientsBySearch({ payload }) {
    try {
        yield put({ type: FETCH_PATIENTS_BY_SEARCH_START })
        const response = yield call(fetchPatientsBySearchAPI, payload.searchObj);

        if (response.success) {
            yield put({ type: FETCH_PATIENTS_BY_SEARCH_SUCCESS, patients: [...response.patients] })
        } else {
            message.error('Failed to fetch patients!');
            yield put({ type: FETCH_PATIENTS_BY_SEARCH_ERROR, error: response.error })

        }
    } catch (error) {
        yield put({ type: FETCH_PATIENTS_BY_SEARCH_ERROR, error: error })
        message.error('Failed to fetch patients!');

    }
}
function* addNewPatient({ payload }) {
    try {
        yield put({ type: ADD_NEW_PATIENT_START })
        const response = yield call(addNewPatientAPI, payload.patient);
        if (response.success) {
            payload.resolve({ success: true, patient: { ...response.patient }  })
            message.success('Added patient successfully!');
            yield put({ type: ADD_NEW_PATIENT_SUCCESS, patient: { ...response.patient } })
        } else {
            yield put({ type: ADD_NEW_PATIENT_ERROR })
            payload.resolve({ success: false })
            if (response.error && response.error.response.data === 'The patient already exists with the same first name, last name, and Dob!') {
                message.error({ content: response.error.response.data, key: 'patient-existing-response-error' })
            } else {
                message.error({ content: 'Failed to add patient!', key: 'patient-response-error' });
            }

            // yield put({ type: ADD_NEW_PATIENT_ERROR, error: response.error })
        }
    }
    catch (error) {
        payload.resolve({ success: false })
        yield put({ type: ADD_NEW_PATIENT_ERROR })
        if (error.response && error.response.data === 'The patient already exists with the same first name, last name, and Dob!') {
            message.error({ content: error.response.data, key: 'patient-existing-patient-error' })
        } else {
            message.error({ content: 'Failed to add patient!', key: 'patient-error' });
        }
    }
}

function* updatePatient({ payload }) {
    try {
        yield put({ type: UPDATE_PATIENT_START })
        const response = yield call(addNewPatientAPI, payload.patient);

        if (response.success) {
            payload.resolve({ success: true })
            message.success('Updated patient successfully!');
            yield put({ type: UPDATE_PATIENT_SUCCESS, patient: { ...response.patient } })
        } else {
            payload.resolve({ success: false })
            message.error({ content: 'Failed to update patient!', key: 'update-patient-response-error' })
            yield put({ type: UPDATE_PATIENT_ERROR })
        }

    }
    catch (error) {
        payload.resolve({ success: false });
        yield put({ type: UPDATE_PATIENT_ERROR })
        message.error({ content: 'Failed to update patient!', key: 'update-error' })
    }
}

function* uploadPatientDocument({ payload }) {
    try {
        const response = yield call(uploadPatientDocumentAPI, payload.documents, payload.patientId);
        const result = yield call(getPatientDocumentsAPI, payload.patientId);
        const patients = yield select(getPatientsState);

        var selectedPatient = patients.selectedPatient;
        if (response.success) {


            if (result.success) {

                if (selectedPatient) {
                    selectedPatient.documents = _.cloneDeep(result.data);
                }

            }

            message.success('Uploaded patient document successfully!');
            yield put({ type: UPLOAD_PATIENT_DOCUMENT_SUCCESS, selectedPatient: _.cloneDeep(selectedPatient) })
        } else {
            message.error({ content: 'Failed to upload patient document!', key: 'patient-doc-error' })
            let modifiedPatient = _.cloneDeep(selectedPatient[0]);
            modifiedPatient.documents = _.cloneDeep(result.data)
            yield put({ type: UPLOAD_PATIENT_DOCUMENT_ERROR, patient: _.cloneDeep(modifiedPatient) })
        }
    }
    catch (error) {
        message.error({ content: 'Failed to upload patient document!', key: 'patient-doc-error' })
        // yield put({ type: UPLOAD_PATIENT_DOCUMENT_ERROR, patient: modifiedPatient })

    }
}
function* fetchPatientDocuments({ payload }) {
    try {

        const response = yield call(getPatientDocumentsAPI, payload.patientId);

        if (response.success) {
            yield put({ type: FETCH_PATIENT_DOCUMENTS_SUCCESS, patientDocuments: _.cloneDeep(response.data) })


        } else {
            yield put({ type: FETCH_PATIENT_DOCUMENTS_ERROR, error: response.error })
        }

    }
    catch (error) {
        yield put({ type: FETCH_PATIENT_DOCUMENTS_ERROR, error: error })

    }
}


function* fetchPatientNotes({ payload }) {
    try {

        const response = yield call(fetchPatientNotesAPI, payload.patientId);

        if (response.success) {
            yield put({ type: FETCH_PATIENT_NOTES_SUCCESS, patientNotes: _.cloneDeep(response.data) })

        } else {
            message.error(response.error)
            yield put({ type: FETCH_PATIENT_NOTES_ERROR, error: response.error })
        }
    }
    catch (error) {
        message.error(error);
        yield put({ type: FETCH_PATIENT_NOTES_ERROR, error: error })

    }
}

function* addUpdatePatientNotes({ payload }) {
    try {
        // yield put({})
        const response = yield call(addUpdatePatientNotesAPI, payload.notes);
        if (response.success) {
            payload.resolve({ success: true })
            message.success('Updated patient notes successfully!');
            yield put({ type: ADD_UPDATE_PATIENT_NOTES_SUCCESS, patientNotes: response.data.length > 0 ? [...response.data] : [] })
        } else {
            payload.resolve({ success: false })
            message.error({ content: 'Failed to update patient notes!', key: 'note-event' })
            // yield put({ type: ADD_UPDATE_PATIENT_NOTES_ERROR, patientNotes: [] })
        }

    }
    catch (error) {
        payload.resolve({ success: false })
        message.error({ content: 'Failed to update patient notes!', key: 'note-error-event' });
        yield put({ type: ADD_UPDATE_PATIENT_NOTES_ERROR, 'patientNotes': [] })

    }
}

function* mergePatients({ payload }) {
    try {

        const response = yield call(mergePatientsAPI, payload.toBeDeletedPatientId, payload.retainedPatientId );

        if (response.success) {
            payload.resolve({ success: true })
            message.success('Merged patient Successfully!');
            yield put({ type: MERGE_PATIENTS_SUCCESS, patientNotes: response.data.length > 0 ? [...response.data] : [] })
            yield put({ type: REMOVE_MERGE_PATIENTS, toBeDeletedPatientId: payload.toBeDeletedPatientId  })
        } else {
            payload.resolve({ success: false })
            message.error({ content: 'Failed to merge patient!', key: 'note-event' })
        }


    }
    catch (error) {
        payload.resolve({ success: false })
        message.error({ content: 'Failed to merge patient!', key: 'merge-patients-error' });
        yield put({ type: MERGE_PATIENTS_ERROR, error: error })

    }
}

function* deletePatientDocument({ payload }) {
    try {

        const response = yield call(deletePatientDocumentAPI, payload.documentId, payload.patientId);


        if (response.success) {
            payload.resolve({ success: true })
            const patients = yield select(getPatientsState);
            var selectedPatient = patients.selectedPatient;
            if (selectedPatient) {
                var documents = (selectedPatient.documents || []).filter(
                    doc => String(doc.documentId) !== String(payload.documentId)
                );

                selectedPatient.documents = _.cloneDeep(documents);
                message.success('Deleted patient document successfully!');
                yield put({ type: DELETE_PATIENT_DOCUMENT_SUCCESS, selectedPatient: _.cloneDeep(selectedPatient) })
            }

        } else {
            payload.resolve({ success: false })
            message.error({ content: 'Failed to delete patient document!', key: 'document-error' });
            yield put({ type: DELETE_PATIENT_DOCUMENT_ERROR, error: response.error })
        }

    }
    catch (error) {
        payload.resolve({ success: false })
        message.error({ content: 'Failed to delete patient document!', key: 'document-error' });
        yield put({ type: DELETE_PATIENT_DOCUMENT_ERROR, error: error })

    }
}

function* setSelectedPatient({ payload }) {
    try {
        yield put({ type: SET_SELECTED_PATIENT_SUCCESS, patient: { ...payload.patient } });
        navigateTo({
            pathname: `/receptionist/patient-visits/${payload.patient.patientId}/${payload.visitId}`,
            state: payload
        });
    } catch (error) {
        message.error(error)
    }
}

function* patinetsWatcher() {
    yield takeLatest(FETCH_PATIENTS_BY_SEARCH, fetchPatientsBySearch)
    yield takeLatest(SET_SELECTED_PATIENT, setSelectedPatient)

}

function* updatePatientWatcher() {
    yield takeLatest(UPDATE_PATIENT, updatePatient)
}

function* addNewPatientWatcher() {
    yield takeLatest(ADD_NEW_PATIENT, addNewPatient)
}

function* uploadPatientDocumentsWatcher() {
    yield takeLatest(UPLOAD_PATIENT_DOCUMENT, uploadPatientDocument)
}

function* fetchPatientDocumentsWatcher() {
    yield takeLatest(FETCH_PATIENT_DOCUMENTS, fetchPatientDocuments)
}

function* fetchPatientNotesWatcher() {
    yield takeLatest(FETCH_PATIENT_NOTES, fetchPatientNotes)
}

function* addUpdatePatientNotesWatcher() {
    yield takeLatest(ADD_UPDATE_PATIENT_NOTES, addUpdatePatientNotes)
}

function* mergePatientsWatcher() {
    yield takeLatest(MERGE_PATIENTS, mergePatients) 
}

function* deletePatientDocumentWatcher() {
    yield takeLatest(DELETE_PATIENT_DOCUMENT, deletePatientDocument)
}

export default function* rootSaga() {
    yield all([patinetsWatcher(),
    addNewPatientWatcher(),
    updatePatientWatcher(),
    uploadPatientDocumentsWatcher(),
    fetchPatientDocumentsWatcher(),
    fetchPatientNotesWatcher(),
    addUpdatePatientNotesWatcher(),
    mergePatientsWatcher(),
    deletePatientDocumentWatcher()])
}